export default "__VITE_ASSET__DnKlhlGX__ 640w, __VITE_ASSET__Cl4p9bfV__ 1024w, __VITE_ASSET__vi4LXz1v__ 1920w";